/**
 * Brand mark for The Society OS.
 *
 * Two lockup variants:
 *   • "landing" (default) — compact horizontal lockup used on the public site
 *   • "portal"           — wider stacked-wordmark lockup used inside the app
 *
 * Both assets are already tightly cropped, so we render at the given pixel
 * height and let the width scale naturally.
 */
const LOGO_LANDING =
  "https://customer-assets-0z36b82j.emergentagent.net/job_unit-ledger-4/artifacts/dmfqpgqy_the%20society%20os%20logo%201.png";
const LOGO_PORTAL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_unit-ledger-4/artifacts/kptzvgrk_TSO%20-%20Landscape.png";

export function BrandMark({ className = "", size = 44, variant = "landing" }) {
  const src = variant === "portal" ? LOGO_PORTAL : LOGO_LANDING;
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={src}
        alt="The Society OS"
        draggable={false}
        className="block select-none"
        style={{ height: size, width: "auto" }}
      />
    </div>
  );
}
